import React from 'react'; // eslint-disable-line

import constants from '../../constants';
import i18n from '../../i18n';
import BackArrow from '../svg/preview/BackArrow';
import Share from '../svg/preview/Share';

const PreviewColors = (props) => {
    return (
        <div className={`preview-content preview-content_design__colors 
            ${props.version.baseColorTheme === constants.ColorBaseTheme
            .find((n) => { return n.Name === 'Dark'; }).Id
            ? 'dark-preview' : 'light-preview'
        }`}
        >

            <div className="status-bar" />

            <div className="module-preview colors-preview">

                <div className="preview-top-nav">
                    <div className="preview-top-nav-inside">
                        <BackArrow />
                    </div>
                </div>

                <div className="preview-image-placeholder" />

                <div className="preview-content-inside">
                    <h5
                        className="accent-color"
                        style={{ color: props.version.accentColor }}
                    >
                        {i18n.t('previews.colors.featured')}
                    </h5>
                    <h2
                        className="primary-text"
                        style={{ color: props.version.primaryText }}
                    >
                        {i18n.t('previews.colors.featured-title')}
                    </h2>

                    <div className="date-wrap">
                        <h6
                            className="secondary-text"
                            style={{ color: props.version.secondaryText }}
                        >
                            {i18n.t('previews.colors.date')}
                        </h6>
                        <Share />
                    </div>

                    <div className="text-content-wrap">
                        <p
                            className="secondary-text"
                            style={{ color: props.version.secondaryText }}
                        >
                            {i18n.t('previews.colors.body1')}
                        </p>
                        <p
                            className="secondary-text"
                            style={{ color: props.version.secondaryText }}
                        >
                            {i18n.t('previews.colors.body2')}
                        </p>
                    </div>
                    <div className="button-wrap">
                        <div
                            className="button action-color"
                            style={{ 
                                backgroundColor: props.version.actionColor
                             }}
                        >
                            {i18n.t('previews.colors.button')}
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );
};

export default PreviewColors;
